import { useContext, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import SkeletonLoader from "src/components/common/skeletonLoading";
import { RetentionSearchContext } from "../search";
import { getSuggestedCalc } from "src/redux/shopping_cart/thunks";
import { selectDataSuggested } from "src/redux/shopping_cart/shopping_cart.selectors";
import { Wrapper } from "../calculo-sugeridos/styles";
import { BodyCartArea, CheckoutCartArea, WrapperCommercialCart } from "./CommercialCart.styles";
import MonthPeriodSelect from "./MonthPeriodSelect";
import OrderSummary from "./OrderSummary";
import PaymentMethodSelect from "./PaymentMethodSelect";
import ProducsSelectable from "./ProducsSelectable/ProducsSelectable";

const EMPTY_COPY = "Busca un cliente por correo electrónico para ver el catálogo y armar el carrito.";
const NOT_FOUND_COPY = "No se encontró información para el cliente buscado.";

/**
 * Tab "Carrito Comercial".
 *
 * El buscador vive a nivel de página; este tab solo arma el pedido (catálogo + checkout).
 * Carga perezosa: dispara `getSuggestedCalc` con el cliente buscado (`submittedQuery`).
 * Guarda: no recarga si el cliente ya está cargado, para no reiniciar la selección del carrito.
 */
const CommercialCart = () => {
    const dispatch = useAppDispatch();
    const { submittedQuery } = useContext(RetentionSearchContext);
    const { loading, errorMessage, suggested } = useAppSelector(selectDataSuggested);

    const loadedEmail = suggested.users.email;
    const isAlreadyLoaded =
        submittedQuery !== "" && loadedEmail.toLowerCase() === submittedQuery.toLowerCase();

    useEffect(() => {
        if (!submittedQuery || isAlreadyLoaded) return;
        dispatch(getSuggestedCalc({ country: "MX", email: submittedQuery, type_user: 2 }));
    }, [submittedQuery, isAlreadyLoaded, dispatch]);

    if (!submittedQuery) {
        return <Wrapper>{EMPTY_COPY}</Wrapper>;
    }

    if (loading) {
        return (
            <Wrapper>
                <SkeletonLoader width="254px" height="20px" count={3} />
                <SkeletonLoader width="180px" height="20px" count={2} />
            </Wrapper>
        );
    }

    if (errorMessage || loadedEmail === "") {
        return <Wrapper>{errorMessage || NOT_FOUND_COPY}</Wrapper>;
    }

    return (
        <WrapperCommercialCart>
            <BodyCartArea>
                <MonthPeriodSelect />
                <ProducsSelectable />
            </BodyCartArea>
            <CheckoutCartArea>
                <PaymentMethodSelect />
                <OrderSummary />
            </CheckoutCartArea>
        </WrapperCommercialCart>
    );
};

export default CommercialCart;
